import React from "react";
import { connect } from "react-redux";
import Formsy from "formsy-react";

import { Button, Col, Modal, Panel, Row } from "react-bootstrap";
import Select from "react-select";
import translator from "../../../components/localization/translator";
import axios from "axios";

import { BASE_URL } from "../../../config";
import restaurantConf from "../../../config/restaurant";

import "./restaurant.details.css";
import commonInformation from "./commonInformation";

class BranchDetails extends commonInformation {
    constructor(props) {
        super(props);
        this.state = {
            isDisabled: true,
        };
        this.form = null;
    }

    setFormRef = (ref) => {
        this.form = ref;
    };

    renderRemoveBranchButton(branchId) {
        return (
            <span
                className={"glyphicon glyphicon-trash pull-right red-color"}
                onClick={(e) => {
                    e.stopPropagation();
                    this.props.removeBranch(branchId);
                }}
            />
        );
    }

    renderBranchDetails() {
        const { branch, branchIndex: i } = this.props;
        const item = {
                ...branch.restaurantInformation,
                _id: branch._id,
            },
            address = item.location ? item.location.address : "",
            addressEn = item.location ? item.location.addressEn : "",
            addressRu = item.location ? item.location.addressRu : "",
            hint = item.hint,
            hintEn = item.hintEn,
            hintRu = item.hintRu,
            branchKey = item.branchKey || "",
            phoneNumbers = item ? item.phoneNumbers : "",
            isPickupCooperation = item ? item.isPickupCooperation : "",
            isProductManagement = item ? item.productManagement : false,
            coordinates = item.location.coordinates,
            workingHours = item.workingHours,
            holidays = item.holidays,
            nonWorkingDays = item.nonWorkingDays,
            isFromBackEntrance = item.isFromBackEntrance,
            name = branch.name,
            nameEn = branch.nameEn || "",
            nameRU = branch.nameRu || "",
            distanceCalcExcludedPartner = item.distanceCalcExcludedPartner,
            validations = restaurantConf.validations,
            key = branch._id || i,
            haysellRegion = item.haysell ? item.haysell.region : "",
            deliveryRegionName = item.deliveryRegionName ? item.deliveryRegionName : "";

        const restaurantInformation = item || {};
        const districtValidations = {
            required: false,
            validations: {},
            validationErrors: {},
            disabled: true,
        };

        return (
            <Panel
                key={key}
                expanded={branch.isExpanded}
                className="nested-custom-panel"
                onSelect={() => {
                    branch.isExpanded = !branch.isExpanded;
                    this.forceUpdate();
                }}
            >
                <Panel.Heading>
                    <Panel.Title>
                        <div
                            style={{
                                position: "relative",
                                paddingRight: "20px",
                            }}
                        >
                            <div
                                style={{
                                    position: "absolute",
                                    top: "14px",
                                    right: "0px",
                                }}
                            >
                                {this.renderRemoveBranchButton(item._id)}
                            </div>
                            <div>
                                {this.nameHandler(
                                    "_branch_name_",
                                    `branch-${i}`,
                                    name,
                                    validations.name,
                                    (e) => {
                                        this.props.nameHandler(e, "branch", i);
                                    }
                                )}
                                {this.nameHandler(
                                    "_branch_name_en",
                                    `branchEn-${i}`,
                                    nameEn,
                                    validations.name,
                                    (e) => {
                                        this.props.nameHandlerEn(
                                            e,
                                            "branchEn",
                                            i
                                        );
                                    }
                                )}
                                {this.nameHandler(
                                    "_branch_name_ru",
                                    `branchRu-${i}`,
                                    nameRU,
                                    validations.name,
                                    (e) => {
                                        this.props.nameHandlerRu(
                                            e,
                                            "branchRu",
                                            i
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    </Panel.Title>
                </Panel.Heading>
                {this.branchKeyHandler(
                    "_branch_key_",
                    `branchKey-${i}`,
                    branchKey,
                    validations.branchKey,
                    (e) => {
                        this.props.branchKeyHandler(e, "branchKey", i);
                    }
                )}
                {this.renderRestaurantPhoneNumbers(
                    "_restaurant_phone_",
                    `phoneNumbers-${i}`,
                    phoneNumbers,
                    validations.phoneNumbers,
                    (e, index) => {
                        this.props.phoneNumbersHandler(e, i, index);
                        this.forceUpdate();
                    }
                )}
                {this.renderRestaurantAddress(
                    "_delivery_region_",
                    `deliveryRegionName-${i}`,
                    deliveryRegionName,
                    {
                        ...validations.deliveryRegionName,
                        disabled: true
                    },
                    (e) => {
                        this.props.deliveryRegionNameHandler && this.props.deliveryRegionNameHandler(e, i);
                    }
                )}
                {this.renderDeliveryRegions("_delivery_regions_", i)}
                {this.renderRestaurantAddress(
                    "_restaurant_address_",
                    `address-${i}`,
                    address,
                    {
                        ...validations.address,
                        required: false
                    },
                    (e) => {
                        this.props.addressHandler(e, "address", i);
                    }
                )}
                {this.renderRestaurantRegion(
                    "_restaurant_region_",
                    `districtAddress-${i}`,
                    restaurantInformation.regionName || "",
                    districtValidations
                )}
                {this.renderRestaurantAddress(
                    "_restaurant_address_en",
                    `addressEn-${i}`,
                    addressEn,
                    validations.address,
                    (e) => {
                        this.props.addressHandler(e, "addressEn", i);
                    }
                )}
                {this.renderRestaurantRegion(
                    "_restaurant_region_en",
                    `districtAddressEn-${i}`,
                    restaurantInformation.regionNameEn || "",
                    districtValidations
                )}
                {this.renderRestaurantAddress(
                    "_restaurant_address_ru",
                    `addressRu-${i}`,
                    addressRu,
                    validations.address,
                    (e) => {
                        this.props.addressHandler(e, "addressRu", i);
                    }
                )}
                {this.renderRestaurantRegion(
                    "_restaurant_region_ru",
                    `districtAddressRu-${i}`,
                    restaurantInformation.regionNameRu || "",
                    districtValidations
                )}
                {this.renderRestaurantAditionalHint(
                    "_restaurant_hint_",
                    `hint-${i}`,
                    hint,
                    {},
                    (e) => {
                        this.props.hintHandler(e, i);
                    }
                )}
                {this.renderRestaurantAditionalHint(
                    "_restaurant_hint_en",
                    `hintEn-${i}`,
                    hintEn,
                    {},
                    (e) => {
                        this.props.hintHandlerEn(e, i);
                    }
                )}
                {this.renderRestaurantAditionalHint(
                    "_restaurant_hint_ru",
                    `hintRu-${i}`,
                    hintRu,
                    {},
                    (e) => {
                        this.props.hintHandlerRu(e, i);
                    }
                )}
                {this.renderCoordinates(
                    {
                        lat: `coordinatesLat-${i}`,
                        lng: `coordinatesLng-${i}`,
                    },
                    coordinates,
                    {
                        lat: (e) => {
                            this.props.coordinatesLatHandler(e, i);
                        },
                        lng: (e) => {
                            this.props.coordinatesLngHandler(e, i);
                        },
                    }
                )}
                {this.renderWorkingHours(
                    {
                        start: `workingHoursStart-${i}`,
                        end: `workingHoursEnd-${i}`,
                    },
                    workingHours,
                    {
                        start: (e) => {
                            this.props.workingHoursStartHandler(e, i);
                        },
                        end: (e) => {
                            this.props.workingHoursEndHandler(e, i);
                        },
                    }
                )}
                {this.renderHolidays(
                    {
                        from: `holidaysFrom-${i}`,
                        to: `holidaysTo-${i}`,
                    },
                    holidays,
                    {
                        from: (e) => {
                            this.props.holidaysFromHandler(e, i);
                        },
                        to: (e) => {
                            this.props.holidaysToHandler(e, i);
                        },
                    }
                )}
                {this.renderNonWorkingDays(nonWorkingDays, (e, index) => {
                    this.props.nonWorkingDaysHandler(e, i, index);
                })}
                {this.renderFromBackEntrance(isFromBackEntrance, (e) => {
                    this.props.isFromBackEntranceHandler(e, i);
                })}
                {this.renderIsPickupCooperation(isPickupCooperation, (e) => {
                    this.props.isPickupCooperationHandler(e, i);
                })}
                {this.renderDistanceCalcDiscludedPartner(
                    distanceCalcExcludedPartner,
                    (e) => {
                        this.props.distanceCalcExcludedPartnerHandler(e, i);
                    }
                )}
                {this.props.isSendToHaysell &&
                    this.renderHaysellRegion(
                        "_haysell_region_",
                        "haysellRegion",
                        haysellRegion,
                        validations.haysellRegion,
                        (e, index) => {
                            this.props.haysellRegionHandler(e, i);
                        }
                    )}
                {this.renderProductManagement(isProductManagement, (e) => {
                    this.props.isProductManagementHandler(e, i);
                })}
            </Panel>
        );
    }

    getDistrict() {
        const restaurantInformation =
            this.props.branch && this.props.branch.restaurantInformation;

        if (!restaurantInformation || !restaurantInformation.location) {
            return;
        }

        const coordinates = restaurantInformation.location.coordinates || {};
        const { lat, lng } = coordinates;

        if (!lat || !lng) {
            return;
        }

        axios
            .get(`${BASE_URL}district`, {
                params: { lat, lng },
            })
            .then((response) => {
                if (!response || !response.data) {
                    return;
                }

                const district = response.data;

                restaurantInformation.regionName = district.name;
                restaurantInformation.regionNameEn = district.nameEn;
                restaurantInformation.regionNameRu = district.nameRu;

                this.forceUpdate();
            })
            .catch(() => {
            });
    }

    renderRestaurantRegion(label, name, value, validations) {
        return this.renderRestaurantAddress(
            label,
            name,
            value,
            validations,
            () => {
            }
        );
    }

    renderDeliveryRegions(label, i) {
        const { regions, branch } = this.props;
        const currentRegionIds = branch.restaurantInformation?.availableRegions || [];

        const options = regions.map((region) => ({
            label: region.name,
            value: region.id || region._id,
        }));

        const selectedOptions = options.filter((opt) =>
            currentRegionIds.includes(opt.value),
        );

        return (
            <div className="display-flex align-center">
                <label className={"label-width"}>
                    {translator.translate(label)}:
                </label>
                <Select
                    className="my-custom-input"
                    isMulti
                    options={options}
                    value={selectedOptions}
                    onChange={(selected) => {
                        branch.restaurantInformation.availableRegions = selected ? selected.map((s) => s.value) : [];
                        this.forceUpdate();
                    }}
                    placeholder={translator.translate(label)}
                />
            </div>
        );
    }

    validateCoordinates() {
        const coordinates =
            this.props.branch.restaurantInformation.location.coordinates;
        return coordinates.lat && coordinates.lng;
    }

    renderFooter() {
        return (
            <Modal.Footer>
                <Row>
                    <Col xs={6}>
                        <Button block onClick={this.props.onClose}>
                            {translator.translate("_cancel_")}
                        </Button>
                    </Col>
                    <Col xs={6}>
                        <Button
                            block
                            bsStyle="primary"
                            type="submit"
                            form="branch-details-form"
                            disabled={!this.validateCoordinates()}
                        >
                            {translator.translate("_save_")}
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        );
    }

    enableButton() {
        this.setState({ isDisabled: false });
    }

    disableButton() {
        this.setState({ isDisabled: true });
    }

    render() {
        return (
            <Modal
                dialogClassName="large-modal"
                show
                onHide={this.props.onClose}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {" "}
                        {translator.translate("_branch_details_")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="scrollable modal-possition">
                    <Formsy
                        id="branch-details-form"
                        ref={this.setFormRef}
                        preventDefaultSubmit
                        noValidate
                        onValid={this.enableButton.bind(this)}
                        onInvalid={this.disableButton.bind(this)}
                        onValidSubmit={this.props.onSave}
                    >
                        {this.renderBranchDetails()}
                    </Formsy>
                </Modal.Body>
                {this.renderFooter()}
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        regions: state.regions,
    };
};

export default connect(mapStateToProps, {})(BranchDetails);
